import Chart from 'chart.js/auto'
import { colors, barChartOptions, formatDateLabel, reduceLabels } from './chart_config'

export function buildAccountChart(canvas, data) {
  const formattedLabels = reduceLabels(data.labels)

  return new Chart(canvas, {
    type: 'bar',
    data: {
      labels: formattedLabels.length ? formattedLabels : data.labels.map(formatDateLabel),
      datasets: [{
        label: 'New Accounts',
        data: data.data,
        backgroundColor: colors.purple[700],
        borderRadius: 4,
        maxBarThickness: 40
      }]
    },
    options: {
      ...barChartOptions,
      plugins: {
        ...barChartOptions.plugins,
        tooltip: {
          ...barChartOptions.plugins.tooltip,
          callbacks: {
            title: (items) => {
              const idx = items[0].dataIndex
              return formatDateLabel(data.labels[idx])
            },
            label: (item) => `${item.raw} new account${item.raw !== 1 ? 's' : ''}`
          }
        }
      }
    }
  })
}
